import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleButton({ role, label = "Continue with Google", testid = "google-login-btn", className = "w-full mt-6 h-11" }) {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const enabled = !!process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const login = useGoogleLogin({
    flow: "auth-code",
    onSuccess: async ({ code }) => {
      try {
        const { data } = await api.post("/auth/google", { code, role });
        if (data?.token) localStorage.setItem("cs_token", data.token);
        const u = await refresh();
        navigate(u?.role === "parent" ? "/parent" : u?.role === "player" ? "/portal" : "/app");
      } catch (e) { toast.error(apiErr(e, "Google sign-in failed")); }
    },
    onError: () => toast.error("Google sign-in was cancelled"),
  });
  if (!enabled) return null;
  return (
    <Button type="button" onClick={() => login()} variant="outline" className={className} data-testid={testid}>
      <img src="https://www.google.com/favicon.ico" alt="" className="h-4 w-4 mr-2" /> {label}
    </Button>
  );
}
